export default 'Please accept the Terms and Conditions and the Privacy Policy'
